import { isCompatible } from './is-compatible';
export const getVersionMismatches = (exposedDependencies, dependencies, sharedDependencies) => {
    const mismatch = Object.entries(exposedDependencies).reduce((result, [dependency, { version: hostVersion }]) => {
        const packageVersion = dependencies[dependency];
        if (packageVersion &&
            !!sharedDependencies[dependency] &&
            !isCompatible(hostVersion, packageVersion)) {
            result[dependency] = { host: hostVersion, package: packageVersion };
        }
        return result;
    }, {});
    for (const [dependency, variable] of Object.entries(sharedDependencies)) {
        const packageVersion = dependencies[dependency];
        if (!exposedDependencies[dependency]) {
            mismatch[dependency] = { host: 'missing', package: packageVersion };
        }
        else if (exposedDependencies[dependency].variable !== variable) {
            mismatch[dependency] = { host: 'wrong global variable', package: packageVersion };
        }
    }
    return mismatch;
};
//# sourceMappingURL=get-version-mismatches.js.map